import {useSelector} from 'react-redux'

import {isAnalyticsDisabledForPrimaryDomain as checkAnalyticsDisabledForPrimaryDomain} from 'definitions/constant/analyticsTenantGate'
import {selectUser} from 'features/User'

interface UseAnalyticsTenantDomainGateReturn {
  isAnalyticsDisabledForPrimaryDomain: boolean
}

/**
 * @description Whether Analytics features gated by primary domain are disabled
 * for the current tenant (Productivity, AI Usage).
 */
export const useAnalyticsTenantDomainGate =
  (): UseAnalyticsTenantDomainGateReturn => {
    const {primaryDomain} = useSelector(selectUser)
    return {
      isAnalyticsDisabledForPrimaryDomain:
        checkAnalyticsDisabledForPrimaryDomain(primaryDomain),
    }
  }
